import * as React from 'react';
import classnames from 'classnames';

import { t } from 'utils/language';

import type { SyntheticEvent } from 'react';

type Props = {
  activeTab: string,
  tabs: Array<string>,
  handleChangeActiveTab: (a: SyntheticEvent<HTMLSpanElement>) => void
};

const SidePanelTabs = ({
  activeTab,
  tabs,
  handleChangeActiveTab
}: Props) => (
  <div className="side-panel-tabs">
    {
      tabs.map(tab => {
        const tabClasses = classnames({
          'side-panel-tabs__item': true,
          'side-panel-tabs__item--active': tab === activeTab
        });

        return (
          <span
            className={tabClasses}
            data-arg={tab}
            onClick={handleChangeActiveTab}
            key={`side-panel-tab-${tab}`}
          >
            {t(`messenger.side_panel_tab.${tab}_label`)}
          </span>
        );
      })
    }
  </div>
);

export default SidePanelTabs;
